import ServEngineIcon from "@/assets/servengine-icon.svg";
import ServEngineLogo from "@/assets/servengine.svg";
import { isAuthenticated } from "@/utils/authHelpers";
import { getSubdomainBranding } from "@/utils/subdomainBranding";
import { Box, Group, Image, Text, Title } from "@mantine/core";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import styles from "../styles/routes/unauthenticated.module.scss";

export const Route = createFileRoute("/_unauthenticated")({
  beforeLoad: async () => {
    // Before loading any unauthenticated routes, check if the user is
    // authenticated and redirect to SPs if so
    if (isAuthenticated()) {
      throw redirect({
        to: "/",
      });
    }
  },
  component: UnauthenticatedLayout,
  loader: async () => {
    // Branding side effects already applied in the root loader. We share the
    // in-flight request via getSubdomainBranding() so this is just a cache
    // read, no extra network call.
    return getSubdomainBranding();
  },
});

function UnauthenticatedLayout() {
  const { subdomainValid, logoUrl } = Route.useLoaderData();

  const logoSection = logoUrl ? (
    <Group style={{ marginBottom: "7rem" }} align="center" gap="xs">
      <Image src={logoUrl} w="auto" h={70} alt="Entity logo" />
    </Group>
  ) : (
    <Group style={{ marginBottom: "7rem" }}>
      <Image src={ServEngineIcon} w="auto" h={70} alt="ServEngine logo" />
      <Image src={ServEngineLogo} w="auto" h={55} alt="ServEngine logo" />
    </Group>
  );

  if (!subdomainValid) {
    return (
      <Box className={styles.unauthenticated_container}>
        {logoSection}
        <Title order={2}>Page Not Found</Title>
        <Text c="dimmed" mt="sm">
          The URL you are trying to access does not exist.
        </Text>
      </Box>
    );
  }

  return (
    <Box className={styles.unauthenticated_container}>
      {logoSection}
      <Outlet />
    </Box>
  );
}
